import { render, staticRenderFns } from "./ConfirmStep.vue?vue&type=template&id=393863b7&scoped=true"
import script from "./ConfirmStep.vue?vue&type=script&lang=ts"
export * from "./ConfirmStep.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmStep.vue?vue&type=style&index=0&id=393863b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393863b7",
  null
  
)

export default component.exports